/* eslint-disable no-unused-expressions */
import { connect } from 'react-redux';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { useEffect, useState } from 'react';
import { modalActions } from '../../../Actions';
import { BaseModal } from '../BaseModal';
import styles from './FileUploaderModal.module.scss';
import DragDropUploader from '../../../Pages/Analytics/Inventory Analytics/UploadPurchaseOrder/DragDropUploader/DragDropUploader';
import { Button } from '@/Components/ui/button';

const FileUploaderModal = (props) => {
	const { show, toggleModal, data } = props;
	const HEADING = `${data.heading}`;
	const [uploadedFile, setUploadedFile] = useState('');
	const [poDId, setPoDId] = useState('');
	const [poDIdError, setPoDIdError] = useState('');

	useEffect(() => {
		if (show && data?.uploadedFile) {
			setUploadedFile(data?.uploadedFile);
		}
		if (show && data?.poDId) {
			setPoDId(data?.poDId);
		}
	}, [show, data]);

	const handleClose = () => {
		toggleModal(false);
		setUploadedFile('');
		setPoDId('');
		setPoDIdError('');
	};
	const handleConfirm = () => {
		// Validate required POI ID when key provided
		if (data?.inputInfo?.mandatory && !poDId?.trim()) {
			setPoDIdError(`${data?.inputInfo?.label} is required`);
			return;
		}
		setPoDIdError('');
		if (data?.handleConfirm) {
			handleClose();
			data?.handleConfirm(uploadedFile, data?.id, poDId);
			setUploadedFile('');
			setPoDId('');
			return;
		}
		props?.handleConfirm(uploadedFile, data?.id, poDId);
		setUploadedFile('');
		setPoDId('');
	};
	const buttons = () => {
		return (
			<div className={styles['btn-container']}>
				<Button
					onClick={handleClose}
					variant='destructive'
					className='flex-1'
				>
					<ClearIcon />
					{data?.cancelText ?? 'Cancel'}
				</Button>
				<Button
					onClick={handleConfirm}
					className='primary-btn flex-1'
					disabled={Boolean(data?.inputInfo?.mandatory) && !poDId?.trim()}
				>
					<CheckIcon />
					{data?.confirmText ?? 'Proceed'}
				</Button>
			</div>
		);
	};

	return (
		<BaseModal
			heading={HEADING}
			height='36rem'
			renderBtns={buttons}
			open={show}
			handleClose={handleClose}
			width='50rem'
		>
			{data?.showInput && (
				<div className='mb-4'>
					<div className='flex items-center gap-3'>
						<label className='w-28 shrink-0 text-sm font-medium text-gray-700'>{data?.inputInfo?.label}</label>
						<input
							type='text'
							value={poDId}
							onChange={(e) => {
								setPoDId(e.target.value);
								if (poDIdError) setPoDIdError('');
							}}
							placeholder={data?.inputInfo?.placeholder}
							required={Boolean(data?.inputInfo?.mandatory)}
							className={`flex-1 rounded-md border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${poDIdError ? 'border-red-500' : 'border-gray-300'}`}
						/>
					</div>
					{poDIdError && (
						<p className='mt-1 text-xs text-red-600 pl-28'>{poDIdError}</p>
					)}
				</div>
			)}
			<DragDropUploader
				uploadType='pdfFile'
				uploadedFile={uploadedFile}
				setUploadedFile={setUploadedFile}
				fileAcceptable='.pdf, application/pdf'
			/>
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state.modal.fileUploaderModal;
	return {
		show,
		data,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleFileUploaderModal,
};
export default connect(mapStateToProps, mapDispatchToProps)(FileUploaderModal);
